import { render, staticRenderFns } from "./Prime.vue?vue&type=template&id=c283ec3c&scoped=true&"
import script from "./Prime.vue?vue&type=script&lang=js&"
export * from "./Prime.vue?vue&type=script&lang=js&"
import style0 from "./Prime.vue?vue&type=style&index=0&id=c283ec3c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c283ec3c",
  null
  
)

export default component.exports